import { InputWrapper } from '@vrplatform/components';
import { useAccountingConnectionQuery } from '@vrplatform/data';
import { Avatar, Group, Text, rem } from '@mantine/core';
import { AutomationMappingEditor } from '../../../components';
import { useListingClassMappingInfo } from '../../../hooks';

type Props = {
  listingId: string;
};

export const ListingClassMappingSelect = ({ listingId }: Props) => {
  const { accounting } = useAccountingConnectionQuery();
  const accountingName = accounting?.name;
  const {
    automation: { accountingConnectionId, automation, finalyticConnectionId },
  } = useListingClassMappingInfo();

  if (!accountingConnectionId || !finalyticConnectionId || !automation)
    return null;

  return (
    <InputWrapper
      label={
        <Group wrap="nowrap" gap={rem(8)}>
          <Text component="span">
            Select class from {accountingName || 'accounting'}
          </Text>
          {accounting?.icon && <Avatar size="xs" src={accounting?.icon} />}
        </Group>
      }
      description="Select the class from your accounting system that corresponds to this listing."
      inputWrapperOrder={['label', 'input', 'description']}
      mb="xs"
      styles={{
        description: {
          marginTop: rem(4),
        },
      }}
    >
      <Select listingId={listingId} />
    </InputWrapper>
  );
};

const Select = ({ listingId }: Props) => {
  const {
    automation: { accountingConnectionId, automation, finalyticConnectionId },
    mapping: { key, leftType, rightType, rightParams, leftParams },
    accounting,
  } = useListingClassMappingInfo();

  if (
    !automation ||
    !accounting ||
    !accountingConnectionId ||
    !finalyticConnectionId
  )
    return null;

  return (
    <AutomationMappingEditor
      automation={{
        automationId: automation.automationId,
        leftConnectionId: finalyticConnectionId,
        rightConnectionId: accountingConnectionId,
        leftAppId: automation.leftConnection?.appId,
        rightAppId: automation.rightConnection?.appId,
        templateId: automation.templateId,
      }}
      mapping={{
        isLocal: false,
        label: 'Listing Class Mapping',
        leftType,
        rightType,
        rightParams,
        leftParams,
        settingKey: key,
        altLeftTypes: [],
        exceptionFilters: undefined,
      }}
      targetId={listingId}
      parentSetting={null}
    />
  );
};
